import envVar from '../config/envVars';
import {
  ElectiveSubjectsMappingResponse,
  UpdateElectiveSubjectsMappingRequestPayload
} from '../types/electiveAssignmentType';
import httpGet from './httpClient/httpGet';
import httpPost from './httpClient/httpPost';

const getStudentElectiveSubjectsMapping = async (
  school: string,
  academicYear: string,
  grade: string,
  division: string,
  termIds: string[] = []
): Promise<ElectiveSubjectsMappingResponse> => {
  const response = await httpGet(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/ay/${academicYear}/grade/${grade}/division/${division}/student-elective-subjects-mapping`,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );

  return response;
};

const updateStudentElectiveSubjectsMapping = async (
  school: string,
  academicYear: string,
  payload: UpdateElectiveSubjectsMappingRequestPayload
) => {
  return httpPost(
    `${envVar.REACT_APP_EXAM_BASE_URL}/students/ay/${academicYear}/student-elective-subjects-mapping`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );
};

const electivesAssignmentApi = {
  getStudentElectiveSubjectsMapping,
  updateStudentElectiveSubjectsMapping
};

export default electivesAssignmentApi;
